import React, { useState } from 'react';

import MassMessage from './MassMessage/MassMessage';
import RegularMessage from './RegularMessage/RegularMessage';
import DayGroupSeparator from './DayGroupSeparator/DayGroupSeparator';

import './css/MessagesList.css';
import PrivateContentMessage from './PrivateContentMessage/PrivateContentMessage';
import GalleryPreviewChat from './PrivateContentMessage/GalleryPreviewChat';
import VideoPreview from './PrivateContentMessage/VideoPreview';
import TippingMessage from './TippingMessage/TippingMessage';
import RequestLiveShowMessage from './RequestLiveShowMessage/RequestLiveShowMessage';
import AudioMessage from './AudioMessage/AudioMessage';
import CalendarNotification from './CalendarNotification/CalendarNotification';
import WishCompletedMessage from './WishCompletedMessage/WishCompletedMessage';
import TemporaryConversationExpiryMessage from './TemporaryConversationExpiryMessage/TemporaryConversationExpiryMessage';


const MessagesList = ({ messages, onMessagesChange, anchors }) => {
  const [galleryToPreview, setGalleryToPreview] = useState([]);
  const [videoToPreview, setVideoToPreview] = useState(null);

  const onGalleryPreview = (gallery) => {
    setGalleryToPreview(gallery);
  };

  const onVideoPreview = (url) => {
    setVideoToPreview(url);
  };

  return (
    <React.Fragment>
      <ul className="messages-list">
        {messages.map((m, idx) => (
          <React.Fragment key={`${m.username}-${m.timestamp}-${m.messageType}-${idx}`}>
            {m.dateGroup && <DayGroupSeparator dateGroup={m.dateGroup} />}
            {(m.isRegularMessage || m.isSmartMessage) && <RegularMessage message={m} anchors={anchors} />}
            {m.isAudioMessage && <AudioMessage resource={m.resource} />}
            {m.isPrivateContentMessage && (
              <PrivateContentMessage
                message={m}
                onGalleryCoverClick={onGalleryPreview}
                onImageLoad={() => onMessagesChange(0)}
                onVideoCoverClick={onVideoPreview}
              />
            )}
            {m.isMassMessage && <MassMessage message={m} />}
            {m.isTippingMessage && <TippingMessage message={m} />}
            {m.isRequestLiveShowMessage && <RequestLiveShowMessage message={m} />}
            {m.isCalendarShowNotification && <CalendarNotification />}
            {m.isWishCompletedMessage && <WishCompletedMessage message={m} />}
            {m.isTemporaryMessagingExpiryReminder && <TemporaryConversationExpiryMessage message={m} />}
          </React.Fragment>
        ))}
      </ul>
      {galleryToPreview.length > 0 && (
        <GalleryPreviewChat
          images={galleryToPreview}
          onClose={() => setGalleryToPreview([])}
        />
      )}
      {videoToPreview && (
        <VideoPreview url={videoToPreview} onClose={() => setVideoToPreview(null)} />
      )}
    </React.Fragment>
  );
};

export default MessagesList;
